import type {HideChatOptions} from "@khan/guide-types";

export const CHAT_INPUT_ICON_HEIGHT = 24;

// As designed to match lefthand message bubble padding for expanded chat UI
export const CHAT_INPUT_EXPANDED_PADDING = 81;

// Hide chat input but do not set an error message
export const HIDE_CHAT_NO_MESSAGE: HideChatOptions = {
    type: "Default",
    message: null,
};
